module.exports = __webpack_public_path__ + "static/media/sfl_5.e27aff4c.jpg";